/**
 * A second act on a show (SCRUM-698 S1). Until now a show got exactly one act, made by «Publish to a show», and
 * nothing in the interface added another — so there was no way to see a changeover. This is the pure half: the
 * show document with one more performance at the end of the running order. `PUT /shows/:id` already accepts it.
 */
import type { Show } from "@scb/schema";

export interface NewPerformance {
  name: string;
  /** A rider that is PUBLISHED at that version (the server checks); absent = the act is booked, its rider has not come. */
  riderId?: string | undefined;
  riderVersion?: number | undefined;
}

type Performance = Show["performances"][number];

export function withPerformance(show: Show, act: NewPerformance, uuid: string): Show {
  const order = show.performances.reduce((last, p) => Math.max(last, p.order), -1) + 1;
  const next: Performance = {
    uuid,
    name: act.name.trim(),
    order,
    line_map: [],
    ...(act.riderId && act.riderVersion !== undefined ? { rider_id: act.riderId, rider_version: act.riderVersion } : {}),
  };
  return { ...show, performances: [...show.performances, next] };
}
